<template>
  <div class="home container-half home-content">
    <div class="moveable-section">

      <transition
        v-on:enter="backArrowEnter"
        v-on:leave="backArrowLeave">
        <a href="#" class="back-arrow-wrap" v-if="showBack" @click.prevent="backData">
          <img src="../assets/back-arrow.svg" alt="">
        </a>
      </transition>

      <div class="animating-type no-shadow" v-if="animating">
        <h1 class="large-heading animates-in shadow" ref="mainHeadingShadow">{{ msg }}</h1>
        <h1 class="large-heading animates-in" ref="mainHeading">{{ msg }}</h1>
      </div>

      <div class="animating-type" v-if="!animating">
        <h1 class="large-heading animates-in" v-html="msg" ref="vueHeading"></h1>
      </div>

      <div class="buttons-wrapper" ref="buttonsWrapper">

        <transition-group
          name="staggered-fade"
          tag="div"
          class="link-container"
          ref="linkContainer"
          v-bind:css="false"
          v-on:before-enter="beforeEnter"
          v-on:appear="enterDelayed"
          v-on:enter="enter"
          v-on:leave="leave"
          appear
        >
          <a
            href="#"
            class="button"
            v-for="(item, index) in questions[current].questions"
            v-bind:key="item.msg"
            v-bind:data-index="index"
            @click.prevent="changeData(item.link)"
            v-bind:class="{ hide: loadingData }"
          >{{ item.msg }} <img src="../assets/forward-arrow.svg" alt="">&nbsp;</a>
        </transition-group>

      </div>

      <transition name="fade-up">
        <router-link to="/contact" class="contact-us-message forward-arrow-wrap" v-if="showMessage">
          <div>
            <p>If you don't fall into any of these categories you may still need to be audited or reviewed, or you may want an audit or review for other reasons.</p>
            <p>Whatever you're needing, <router-link to="/contact">contact us</router-link> and we'll be happy to talk you through the options.</p>
          </div>
          <img src="../assets/forward-arrow-light.svg" alt="">
        </router-link>
      </transition>

    </div>

    <div class="moveable-section" ref="approach">
      <span class="lead">Our approach</span>
      <h1 class="medium-heading">{{ approach.leadIn }}</h1>
      <p class="white">{{ approach.content }}</p>
    </div>

    <div class="moveable-section">
      <span class="lead">About us</span>
      <h1 class="medium-heading">{{ about.leadIn }}</h1>
      <p class="white">{{ about.content }}</p>
    </div>

    <div class="scroll-indicator" ref="scrollIndicator" @click="scrollDown">
      <img src="../assets/scroll-indicator.svg" alt="">
    </div>
  </div>
</template>

<script>
import Velocity from 'velocity-animate'
import { TweenLite } from 'gsap'
import TextEffects from '../assets/custom-modules/text-effects/text-effects.js'
import axios from 'axios'
export default {
  name: 'Home',
  data () {
    return {
      msg: '',
      animating: true,
      loadingData: false,
      showBack: false,
      showMessage: false,
      approach: {
        leadIn: '',
        content: ''
      },
      about: {
        leadIn: '',
        content: ''
      },
      current: 0,
      questions: [
        {
          name: 'Hello! How can we help you today?',
          questions: [
            {
              msg: 'What’s the difference between an audit and a review?',
              link: '/questionnaire/whats-the-difference'
            },
            {
              msg: 'Do I need an audit or a review?',
              link: 'company-type'
            },
            {
              msg: 'What services do you offer?',
              link: '/services'
            },
            {
              msg: 'I need help with AML/CFT.',
              link: '/services/aml-cft-audits'
            }
          ]
        },
        {
          name: 'Which option describes your organisation best?',
          questions: [
            {
              msg: 'Registered Charity',
              link: '/questionnaire/registered-charity'
            },
            {
              msg: 'Incorporated Society',
              link: 'also-charity'
            },
            {
              msg: 'Company',
              link: '/questionnaire/company'
            }
          ]
        },
        {
          name: 'Are you also a registered charity?',
          questions: [
            {
              msg: 'Yes',
              link: '/questionnaire/registered-charity'
            },
            {
              msg: 'No',
              link: '/questionnaire/incorporated-society'
            }
          ]
        }
      ]
    }
  },
  watch: {
    msg (now, before) {
      var el = this.$refs.vueHeading
      if (el) {
        var nowElDim = TextEffects.getPossibleDimensions(now, el)
        Velocity(el, {
          height: nowElDim.height
        }, {
          duration: 500
        })
      }
    },
    current (now, before) {
      this.msg = this.questions[now].name
      if (now === 0) {
        this.showBack = false
        this.showMessage = false
      }
    }
  },
  methods: {
    animateCharacters (chars, shadows) {
      let elements = []

      chars = chars.children
      shadows = shadows.children

      console.log(chars, shadows)

      for (var lineI = 0; lineI < chars.length; lineI++) {
        var line = chars[lineI]
        for (var characterI = 0; characterI < line.children.length; characterI++) {
          let characters = [line.children[characterI], shadows[lineI].children[characterI]]

          Velocity(characters, { top: 0 }, {
            duration: 750,
            delay: ((characterI + 1) * 150) + ((lineI + 1) * 200),
            easing: [ 0, 0.5, 0.5, 1 ],
            queue: 'characters'
          })

          elements.push(line.children[characterI])
          elements.push(shadows[lineI].children[characterI])
        }
      }

      return elements
    },

    beforeEnter: function (el) {
      el.style.opacity = 0
      el.style.transform = 'scale(0.8)'
    },

    enterDelayed: function (el, done) {
      var delay = 1500 + (el.getAttribute('data-index') * 300)
      Velocity(
        el,
        { opacity: 1, scale: 1 },
        { duration: 300, complete: done, delay }
      )
    },

    enter: function (el, done) {
      var delay = 350 + el.getAttribute('data-index') * 300
      Velocity(
        el,
        { opacity: 1, scale: 1 },
        { duration: 300, complete: done, delay }
      )
    },

    leave (el, done) {
      Velocity(
        el,
        { opacity: 0, scale: 0.8 },
        { duration: 300, complete: done }
      )
    },

    backArrowEnter: function (el, done) {
      TweenLite.from(el, 0.3, {
        opacity: 0,
        height: 0,
        onComplete: done
      })
    },

    backArrowLeave (el, done) {
      TweenLite.to(el, 0.3, {
        opacity: 0,
        height: 0,
        onComplete: done
      })
    },

    changeData: function (e) {
      this.$refs.buttonsWrapper.style.height = this.$refs.buttonsWrapper.offsetHeight + 'px'
      if (e === 'company-type' || e === 'also-charity') {
        this.$root.$data.beanState = 'clipboard'
        this.showBack = true
        this.showMessage = true
        if (e === 'company-type') this.current = 1
        if (e === 'also-charity') this.current = 2
      } else {
        this.$router.push(e)
      }
    },

    backData: function (e) {
      this.current = this.current - 1
    },

    initHomepage () {
      if (!this.$refs.mainHeading) {
        console.warn('An error occured getting the homepage heading element.')
        return false
      }
      const chars = TextEffects.splitByCharacter(this.$refs.mainHeading)
      TextEffects.splitByCharacter(this.$refs.mainHeadingShadow)

      const duration = 750
      let transitionLength = chars.length * 150
      transitionLength += duration

      transitionLength += this.$refs.mainHeading.children.length * 200

      this.$nextTick(el => {
        const animated = this.animateCharacters(this.$refs.mainHeading, this.$refs.mainHeadingShadow)
        Velocity.Utilities.dequeue(animated, 'characters')
      })

      window.addEventListener('scroll', () => {
        if (window.scrollY > 500) {
          this.$refs.scrollIndicator.style.opacity = 0
        } else {
          this.$refs.scrollIndicator.style.opacity = 1
        }
      })

      window.setTimeout(e => {
        this.animating = false
        document.dispatchEvent(new Event('content-loaded'))
      }, transitionLength)
    },

    scrollDown () {
      Velocity(this.$refs.approach, 'scroll', {
        offset: -100
      })
    }
  },
  mounted () {
    axios.get(process.env.ENDPOINT, {
      params: {
        slug: 'questionnaire'
      }
    }).then(response => {
      console.log(response)
      this.msg = response.data[0].acf.welcome_text
      this.approach.leadIn = response.data[0].acf.our_approach.lead_in
      this.approach.content = response.data[0].acf.our_approach.content
      this.about.leadIn = response.data[0].acf.about_us.lead_in
      this.about.content = response.data[0].acf.about_us.content
      this.$nextTick(this.initHomepage)
    }).catch(function (error) {
      console.log(error)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue